// Pure engraving-input validation. No DOM, no I/O — unit-testable + reusable in the browser.
// rules: { maxChars, maxLines, charsPerLine, allowedFonts:[], allowSymbols:bool }
function validate(input, rules) {
  const errors = [];
  const text = (input.text || '').trim();
  const lines = text.length ? text.split('\n') : [];

  if (!text && !input.symbol) errors.push('Add a message or symbol to engrave.');
  if (text.length > rules.maxChars) errors.push(`Keep it under ${rules.maxChars} characters.`);
  if (lines.length > rules.maxLines) errors.push(`Maximum ${rules.maxLines} line(s).`);
  if (rules.charsPerLine && lines.some(l => l.length > rules.charsPerLine)) {
    errors.push(`Each line max ${rules.charsPerLine} characters.`);
  }
  if (input.font && rules.allowedFonts.length && !rules.allowedFonts.includes(input.font)) {
    errors.push('That font is not available for this piece.');
  }
  if (input.symbol && !rules.allowSymbols) errors.push('Symbols are not available for this piece.');

  return { valid: errors.length === 0, errors };
}

// UMD-ish export: CommonJS for tests, global for the browser/theme.
if (typeof module !== 'undefined' && module.exports) module.exports = { validate };
else if (typeof window !== 'undefined') window.EngravingRules = { validate };
